<div
  *ngIf="selectedItemList$ | async as selectedItemList; else detailsLoading"
  class="eb-favorites"
>
  <div class="eb-favorites__title">
    <ng-container *ngIf="!isVisible; else showTitleOnly">
      <h3>
        <div
          class="eb-favorites__edit-title"
          contenteditable="true"
          id="editListName"
          role="textbox"
        >
          {{ selectedItemList.name }}
        </div>
      </h3>
      <button
        class="cx-remove-btn link eb-favorites__title-save"
        (click)="saveFavoritesName(selectedItemList)"
      >
        {{ 'common.save' | cxTranslate }}
      </button>
    </ng-container>
    <ng-template #showTitleOnly>
      <div class="eb-favorites__show-title">
        <h3>
          {{ selectedItemList.name }}
          <div
            *ngIf="
              !selectedItemList.recommendationsList &&
              selectedItemList.isOwner &&
              isVisible
            "
            class="eb-favorites__title-edit"
            (click)="toggleEditableState()"
          >
            <em class="fas fa-pen"></em>
          </div>
        </h3>
      </div>
    </ng-template>
  </div>
  <span *ngIf="selectedItemList.savedBy" class="hint">{{
      getI18nToken(selectedItemList)
        | cxTranslate
        : {
          created: (selectedItemList.saveTime | cxDate: 'mediumDate' : 'UTC'),
          by: selectedItemList?.savedBy?.name
        }
    }}</span>
  <div class="eb-favorites__share-bar">
    <span class="hint">{{
      'favorites.details.' + (selectedItemList.shared ? 'shared' : 'private') | cxTranslate
    }}</span>
    <button
      *ngIf="!selectedItemList.recommendationsList && selectedItemList.isOwner"
      class="eb-favorites__share-bar--share-btn link"
      (click)="toggleSharedStatusOfList(selectedItemList)"
    >
      {{ 'favorites.details.' + (selectedItemList.shared ? 'unshare' : 'share') | cxTranslate }}
    </button>
  </div>
  <div class="eb-favorites__action-bar">
    <div class="row eb-favorites__search-bar">
      <label class="eb-favorites__filter" [class.dirty]="!!favoritesSearch.value">
        <button
          [attr.aria-label]="'common.search' | cxTranslate"
          (click)="searchOnFavorites(favoritesSearch.value)"
          class="search-desktop"
        >
          {{ 'common.search' | cxTranslate }}
          <cx-icon type="SEARCH"></cx-icon>
        </button>
        <button
          [attr.aria-label]="'common.search' | cxTranslate"
          (click)="searchOnFavorites(favoritesSearch.value)"
          class="search-mobile"
        >
          <cx-icon type="SEARCH"></cx-icon>
        </button>
        <input
          #favoritesSearch
          (keyup)="searchOnFavorites(favoritesSearch.value)"
          (keyup.enter)="searchOnFavorites(favoritesSearch.value)"
        />
        <button
          [attr.aria-label]="'common.reset' | cxTranslate"
          (mousedown)="clearSearchTerm(); favoritesSearch.value = ''"
          (keyup.enter)="clearSearchTerm(); favoritesSearch.value = ''"
          class="reset"
        >
          <cx-icon type="RESET"></cx-icon>
        </button>
        <div class="search-icon">
          <cx-icon type="SEARCH"></cx-icon>
        </div>
      </label>
    </div>
    <div class="row eb-favorites__action-btn">
      <div class="eb-favorites__action-btn-desktop">
        <button
          class="eb-favorites__action-bar--add-all-to-cart"
          (click)="addFavoriteEntriesToCart()"
          [disabled]="!isFavoriteSelected()"
        >
          {{ 'favorites.details.selected.addToCart' | cxTranslate }}
          <span class="fas fa-cart-plus"></span>
        </button>
        <button
          class="eb-favorites__action-bar--rfq-all"
          (click)="sendAllItemsRfq()"
          [disabled]="!isFavoriteSelected()"
        >
          {{ 'favorites.details.selected.RfQ' | cxTranslate }}
          <cx-icon [type]="IconType.FILE"></cx-icon>
        </button>
        <button
          class="eb-favorites__action-bar--remove-all"
          (click)="deleteFavoriteEntriesFromList(selectedItemList)"
          [disabled]="!isFavoriteSelected()"
        >
          {{ 'favorites.details.selected.remove' | cxTranslate }}
          <span class="fa fa-trash"></span>
        </button>
        <div class="eb-favorites__view-actions">
          <div class="favorites_sort">
            <label class="eb-favorites__sort-label" for="favorites_sort-select">
              {{ 'favorites.details.sort.placeholder' | cxTranslate }}
            </label>
            <select
              id="favorites_sort-select"
              class="eb-favorites__sort-select"
              [(ngModel)]="selectedOption"
              (change)="sortEntries($event.target.value)"
            >
              <option [value]="option.id" *ngFor="let option of sortOptions">
                {{ option.name | cxTranslate }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="eb-favorites__action-btn-mobile">
        <button
          class="eb-favorites__action-bar--add-all-to-cart"
          (click)="addFavoriteEntriesToCart()"
          [disabled]="!isFavoriteSelected()"
        >
          <span class="fas fa-cart-plus"></span>
        </button>
        <button
          class="eb-favorites__action-bar--rfq-all"
          (click)="sendAllItemsRfq()"
          [disabled]="!isFavoriteSelected()"
        >
          <cx-icon [type]="IconType.FILE"></cx-icon>
        </button>
        <button
          class="eb-favorites__action-bar--remove-all"
          (click)="deleteFavoriteEntriesFromList(selectedItemList)"
          [disabled]="!isFavoriteSelected()"
        >
          <span class="fa fa-trash"></span>
        </button>
      </div>
      <div class="eb-favorites__view-actions-mobile">
        <div class="favorites_sort">
          <label class="eb-favorites__sort-label" for="favorites_sort-select">
            {{ 'favorites.details.sort.placeholder' | cxTranslate }}
          </label>
          <select
            id="favorites_sort-select-mobile"
            class="eb-favorites__sort-select"
            [(ngModel)]="selectedOption"
            (change)="sortEntries($event.target.value)"
          >
            <option [value]="option.id" *ngFor="let option of sortOptions">
              {{ option.name | cxTranslate }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
  <div class="eb-favorites__search-results" *ngIf="favoritesSearch.value">
    <ng-container *ngIf="selectedItemList.entries?.length; else emptySearchResult">
      {{ 'favorites.searchTerm' | cxTranslate: { searchTerm: favoritesSearch.value } }}
    </ng-container>
    <ng-template #emptySearchResult>
      {{ 'favorites.searchTerm' | cxTranslate: { searchTerm: favoritesSearch.value } }}
      {{ 'favorites.emptyResult' | cxTranslate }}
    </ng-template>
  </div>
  <div class="eb-favorites__items" *ngIf="selectedItemList.entries?.length > 0">
    <eb-favorites-item-list
      [items]="selectedItemList.entries"
      hideQuantity="true"
      controlled="false"
      showAddToCart="true"
      loadAvailabilities="true"
      [sortBy]="sortEntriesBy$ | async"
      [filterBy]="filterEntriesBy$ | async"
      [isAllSelected]="isAllSelected(selectedItemList.entries)"
      (singleItemSelected)="collectSelectedItem($event)"
      (allItemsSelected)="collectAllSelectedItems($event)"
      (removeSelectedItem)="removeSelectedItem($event, selectedItemList)"
      (editCommentOnEntry)="updateCommentOnEntry($event, selectedItemList)"
    ></eb-favorites-item-list>
    <div *ngIf="!selectedItemList.entries?.length && !isSearchActive" class="eb-favorites__empty">
      {{ 'favorites.details.empty' | cxTranslate }}
    </div>
  </div>
</div>
<ng-template #detailsLoading>
  <eb-spinner alignment="center" width="100%"></eb-spinner>
</ng-template>
